/**
 * Render OpenSearch highlight fragments safely.
 *
 * Backend sends `<em>...</em>` markers in highlight fields. We split the
 * string by those markers and render as React nodes — no innerHTML, no XSS.
 */

import { Fragment } from "react"

const EM_RE = /<em>(.*?)<\/em>/g

export function HighlightSnippet({ html, className }: { html: string; className?: string }) {
  const parts: { text: string; em: boolean }[] = []
  let last = 0
  for (const m of html.matchAll(EM_RE)) {
    if (m.index! > last) parts.push({ text: html.slice(last, m.index), em: false })
    parts.push({ text: m[1], em: true })
    last = m.index! + m[0].length
  }
  if (last < html.length) parts.push({ text: html.slice(last), em: false })

  return (
    <span className={className}>
      {parts.map((p, i) =>
        p.em ? (
          <mark key={i} className="rounded bg-yellow-200/70 px-0.5 text-foreground">
            {p.text}
          </mark>
        ) : (
          <Fragment key={i}>{p.text}</Fragment>
        ),
      )}
    </span>
  )
}
